<template>
      <v-card>
          <v-stepper v-model="step">
              <v-stepper-header>
                <v-stepper-step step="1" :complete="step > 1" v-show="step < 3">
                  Itens do Pedido
                </v-stepper-step>
                <v-stepper-step step="2" :complete="step > 2" v-show="step < 3">
                  Informações do Pedido
                </v-stepper-step>
                <v-stepper-step step="3" :complete="step > 3" v-show="step > 2">
                  Endereço de Entrega
                </v-stepper-step>
                <v-stepper-step step="4" :complete="step > 4" v-show="step > 2">
                  Confirmar Pedido
                </v-stepper-step>
              </v-stepper-header>
              <v-alert
                  :value="true"
                  type="error"
                  style="font-size: 1.2em"
                  class="pa-2"
                  v-if="alerta"
              >
                  {{ alerta }}
              </v-alert>
              <v-stepper-items>
                  <v-stepper-content step="1" id="itens_pedido">
                       <v-layout wrap justify-space-between>
                          <v-flex xs6>
                            <v-autocomplete
                              label="Selecione um item"
                              outline
                              item-value="id"
                              item-text="nome"
                              v-model="item"
                              :items="itens"
                              :disabled="itens.length === 0"
                              @change="quantidade = 1"
                              return-object
                            />
                          </v-flex>
                          <v-flex xs3>
                            <v-text-field
                              label="Quantidade"
                              outline
                              v-model="quantidade"
                              :disabled="!item"
                              type="number"
                              :rules="[
                                v => (!!v && v > 0) || 'Quantidade inválida'
                              ]"
                            />
                          </v-flex>
                          <v-flex xs2>
                            <v-btn icon color="primary" @click="adicionarItem">
                              <v-icon>add</v-icon>
                            </v-btn>
                          </v-flex>
                          <v-flex xs12>
                            <h2 class="text-xs-center">Itens adicionados ao pedido</h2>
                            <v-list three-line>
                              <v-list-tile v-for="(item, index) in itens_pedido" :key="index">
                                <v-list-tile-content>
                                  <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                                  <v-list-tile-sub-title>{{ item.preco | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                                  <v-list-tile-sub-title>{{ item.quantidade }} unidade(s)</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-sub-title>{{ (item.preco * item.quantidade) | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-action>
                                  <v-btn icon flat color="error" @click="removerItem(item, index)">
                                    <v-icon>delete</v-icon>
                                  </v-btn>
                                </v-list-tile-action>
                              </v-list-tile>
                            </v-list>
                          </v-flex>
                          <v-flex xs12>
                            <h3 class="text-xs-center">Valor total estimado: {{ subtotal | currency({ frameElement: 2 }) }}</h3>
                          </v-flex>
                      </v-layout>
                      <v-card-actions class="justify-space-around mt-4">
                          <v-flex xs6>
                            <v-btn
                              @click="fecharCard"
                              block
                              flat
                            >
                              Fechar
                            </v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn
                              color="primary"
                              block
                              flat
                              @click="nextStep"
                              :disabled="itens_pedido.length === 0"
                            >
                              Próximo
                            </v-btn>
                          </v-flex>
                      </v-card-actions>
                  </v-stepper-content>
                  <v-stepper-content step="2" id="dados_pedido">
                    <v-form ref="formDadosPedido" v-model="valid" lazy-validation>
                      <v-layout wrap justify-space-between v-if="step === 2">
                        <v-flex xs5>
                          <v-text-field
                            label="Taxa de entrega"
                            outline
                            v-money="money"
                            v-model.lazy="pedido_data.taxa_entrega"
                            prefix="R$"
                            :rules="[  v => !!v || 'Taxa de entrega é obrigatória']"
                            required
                          />
                        </v-flex>
                        <v-flex xs5>
                          <v-autocomplete
                            label="Forma de pagamento"
                            outline
                            :items="tipos_pagamentos"
                            item-text="descricao"
                            item-value="id_tipo_pagamento"
                            v-model="tipo_pagamento_selecionado"
                            return-object
                           :rules="[  v => !!v || 'Forma de pagamento é obrigatória']"
                           required
                          />
                        </v-flex>
                        <v-flex xs5>
                          <v-menu
                            v-model="menu"
                            :close-on-content-click="false"
                            lazy
                            transition="slide-y-transition"
                            offset-y
                            full-width
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                label="Data prevista para entrega"
                                outline
                                v-model="data_entrega_prevista_formatada"
                                :loading="loading"
                                box
                                v-on="on"
                                :rules="[  v => !!v || 'Data prevista para entrega é obrigatória']"
                                required
                              />
                            </template>
                            <v-date-picker
                              v-model="pedido_data.data_entrega_prevista"
                              no-title
                              scrollable
                              color="primary"
                              locale="pt-br"
                              :allowed-dates="(date) => {
                                return Date.parse(date) >= today
                              }"
                              required
                              :rules="[  v => !!v || 'Data prevista para entrega é obrigatória']"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs5>
                          <v-text-field
                            label="Desconto"
                            outline
                            v-money="money"
                            v-model.lazy="pedido_data.desconto"
                            prefix="R$"
                            :rules="[  v => !!v || 'Desconto é obrigatório']"
                            required
                          />
                        </v-flex>
                         <v-flex xs12>
                            <h3 class="text-xs-center">Total: {{ valor_total | currency({ frameElement: 2 }) }}</h3>
                          </v-flex>
                      </v-layout>
                    </v-form>
                    <v-card-actions class="justify-space-around mt-4">
                      <v-flex xs6>
                            <v-btn
                              @click="step--"
                              block
                              flat
                            >
                              Voltar
                            </v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn
                              color="primary"
                              block
                              flat
                              @click="nextStep"
                              :disabled="!valid || !data_entrega_prevista_formatada || !pedido_data.data_entrega_prevista || !tipo_pagamento_selecionado"
                            >
                              Próximo
                            </v-btn>
                          </v-flex>
                    </v-card-actions>
                  </v-stepper-content>
                  <v-stepper-content step="3"  id="endereco_entrega">
                    <v-checkbox
                      style="
                          justify-content: center;
                          align-items: center;
                      "
                      color='primary'
                      v-model='eh_mesmo_endereco'
                      label='O endereço de entrega será o mesmo do endereço de cadastro?'
                    ></v-checkbox>

                    <h4
                      class="text-xs-center"
                      v-if="eh_mesmo_endereco && cliente && cliente.endereco"
                    >
                      {{ cliente.endereco.logradouro }}, {{ cliente.endereco.numero }}, {{ cliente.endereco.bairro }}, {{ cliente.endereco.cidade }}
                    </h4>

                    <v-form ref="formEnderecoEntrega" v-model="validEnderecoEntrega" lazy-validation v-show="!eh_mesmo_endereco">
                          <v-container grid-list-md>
                              <v-layout wrap>
                                <v-flex xs12 sm12>
                                  <v-text-field
                                    label="CEP*"
                                    @keyup="searchCep()"
                                    v-model="endereco_entrega.cep"
                                    mask="#####-###"
                                    :rules="cepRules"
                                    outline
                                    required
                                  >
                                    <template v-slot:append>
                                      <v-icon
                                        color="primary"
                                        @click="searchCep()"
                                        :disabled="!endereco_entrega.cep || endereco_entrega.cep.replace(/\D/g, '').length !== 8"
                                      >
                                        search
                                      </v-icon>
                                    </template>
                                  </v-text-field>
                                </v-flex>

                                <v-flex xs12>
                                  <v-text-field
                                    label="Logradouro*"
                                    v-model="endereco_entrega.logradouro"
                                    :rules="logradouroRules"
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm3>
                                  <v-text-field
                                    label="Número*"
                                    v-model="endereco_entrega.numero"
                                    :rules="numeroRules"
                                    required
                                    type="number"
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm4>
                                  <v-text-field
                                    label="Complemento"
                                    v-model="endereco_entrega.complemento"
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm5>
                                  <v-text-field
                                    label="Bairro*"
                                    v-model="endereco_entrega.bairro"
                                    :rules="bairroRules"
                                    required
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm6>
                                  <v-text-field
                                    label="Cidade*"
                                    v-model="endereco_entrega.cidade"
                                    :rules="cidadeRules"
                                    required
                                    outline
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                                <v-flex xs12 sm6>
                                  <v-select
                                    label="Estado*"
                                    v-model="endereco_entrega.estado"
                                    :items="estados"
                                    :rules="estadoRules"
                                    outline
                                    required
                                    :disabled="!cepValido"
                                  />
                                </v-flex>

                              </v-layout>
                          </v-container>
                      </v-form>
                      <v-card-actions class="justify-space-around mt-4">
                        <v-flex xs6>
                              <v-btn
                                @click="step--"
                                block
                                flat
                              >
                                Voltar
                              </v-btn>
                            </v-flex>
                            <v-flex xs6>
                              <v-btn
                                color="primary"
                                block
                                flat
                                @click="nextStep"
                                :disabled="!eh_mesmo_endereco && (!endereco_entrega.cep && !endereco_entrega.numero)"
                              >
                                Próximo
                              </v-btn>
                            </v-flex>
                      </v-card-actions>
                    </v-stepper-content>
                  <v-stepper-content step="4" id="conferir_informacoes">
                    <v-layout wrap justify-space-between v-if="step === 4">
                      <v-flex xs5>
                          <b>Data prevista de entrega:</b> {{ pedido_data.data_entrega_prevista | formatDate('DD/MM/YYYY') }}
                      </v-flex>
                      <v-flex xs5>
                          <b>Taxa de entrega:</b> {{ formatarValor(pedido_data.taxa_entrega) | currency({ fractionCount: 2 }) }}
                      </v-flex>
                      <v-flex xs5 v-if="formatarValor(pedido_data.desconto) > 0">
                        <b>Desconto:</b> {{ formatarValor(pedido_data.desconto) | currency({ fractionCount: 2 }) }}
                      </v-flex>
                      <v-flex xs5 v-if="pedido_data.tipo_pagamento">
                        <b>Tipo de pagamento:</b> {{ tipo_pagamento_selecionado.descricao }}
                      </v-flex>
                      <v-flex xs12 v-if="pedido_data.endereco_entrega">
                        <b>Endereço de entrega:</b> {{ pedido_data.endereco_entrega.logradouro }}, {{ pedido_data.endereco_entrega.numero }}, {{ pedido_data.endereco_entrega.bairro }}, {{ pedido_data.endereco_entrega.cidade }}, CEP:  {{ pedido_data.endereco_entrega.cep }} - {{ pedido_data.endereco_entrega.estado }}
                      </v-flex>
                      <v-flex xs12>
                          <v-divider></v-divider>
                      </v-flex>
                      <template v-if="cliente">
                        <v-flex xs12 class="mb-2">
                          <h3 class="text-xs-center">Informações do cliente</h3>
                        </v-flex>
                        <v-flex xs5>
                            <b>Nome:</b> {{ cliente.nome }}
                        </v-flex>
                        <v-flex xs5>
                            <b>Telefone:</b> {{ cliente.telefone | formataTelefone }}
                        </v-flex>
                      </template>
                      <v-flex xs12>
                        <v-divider></v-divider>
                      </v-flex>
                      <template v-if="itens_pedido && itens_pedido.length > 0">
                        <v-flex xs12 class="mb-2">
                          <h3 class="text-xs-center">Itens do pedido</h3>
                        </v-flex>
                        <v-flex xs12 v-if="itens_pedido">
                          <v-list three-line>
                            <v-list-tile v-for="(item, index) in itens_pedido" :key="index">
                              <v-list-tile-content>
                                  <v-list-tile-title>{{ item.nome }}</v-list-tile-title>
                                  <v-list-tile-sub-title>{{ item.preco | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                                  <v-list-tile-sub-title>{{ item.quantidade }} unidade(s)</v-list-tile-sub-title>
                                </v-list-tile-content>
                                <v-list-tile-content>
                                  <v-list-tile-sub-title>{{ (item.preco * item.quantidade) | currency({ frameElement: 2 }) }}</v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                          </v-list>
                        </v-flex>
                      </template>
                    </v-layout>
                    <v-alert :value="true" type="info" >
                      <h3>Total a pagar: {{ valor_total | currency({ frameElement: 2 }) }}</h3>
                    </v-alert>
                    <v-card-actions class="justify-space-around mt-4">
                      <v-flex xs6>
                            <v-btn
                              @click="step--"
                              block
                              flat
                            >
                              Voltar
                            </v-btn>
                          </v-flex>
                          <v-flex xs6>
                            <v-btn
                              color="primary"
                              block
                              flat
                              @click="nextStep"
                            >
                              Realizar Pedido
                            </v-btn>
                          </v-flex>
                    </v-card-actions>
                  </v-stepper-content>
              </v-stepper-items>
          </v-stepper>
  </v-card>
</template>

<script>
import { VMoney } from 'v-money'
export default {
  directives: { money: VMoney },
  props: ['cliente'],
  data: () => ({
    step: 1,
    today: undefined,
    valid: true,
    validEnderecoEntrega: true,
    menu: false,
    cepValido: false,
    itens: [],
    itens_pedido: [],
    tipos_pagamentos: [],
    estados: ['AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG', 'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'],
    eh_mesmo_endereco: true,
    item: undefined,
    tipo_pagamento_selecionado: undefined,
    data_entrega_prevista_formatada: undefined,
    pedido_data: {
      taxa_entrega: '0,00',
      endereco_entrega: undefined,
      data_entrega: undefined,
      data_envio: null,
      tipo_pagamento: undefined,
      data_entrega_prevista: undefined,
      desconto: '0,00',
      total: 0,
      subtotal: 0,
      finalizado: true,
      itens_pedido: []
    },
    quantidade: 1,
    alerta: undefined,
    tipo: 'error',
    endereco_entrega: {
      logradouro: undefined,
      numero: undefined,
      bairro: undefined,
      cidade: undefined,
      estado: undefined,
      cep: undefined,
      complemento: undefined,
      latitude: undefined,
      longitude: undefined
    },
    money: {
      decimal: ',',
      thousands: '.',
      prefix: '',
      precision: 2,
      masked: false
    },
    logradouroRules: [v => !!v || 'Logradouro é obrigatório'],
    numeroRules: [v => !!v || 'Número é obrigatório'],
    bairroRules: [v => !!v || 'Bairro é obrigatório'],
    cidadeRules: [v => !!v || 'Cidade é obrigatória'],
    estadoRules: [v => !!v || 'Estado é obrigatório'],
    cepRules: [
      v => !!v || 'CEP é obrigatório',
      v => (!!v && v.replace(/\D/g, '').length === 8) || 'CEP inválido'
    ]
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    frentista () {
      return this.$store.getters.frentista
    },
    subtotal () {
      return (this.itens_pedido.reduce((acumulador, item) => acumulador + item.preco * item.quantidade, 0)).toFixed(2)
    },
    valor_total () {
      if (!this.itens_pedido.length) return 0
      return (this.subtotal - this.formatarValor(this.pedido_data.desconto) + this.formatarValor(this.pedido_data.taxa_entrega)).toFixed(2)
    },
    empresa () {
      return this.$store.getters.empresa
    }
  },
  beforeMount () {
    const today = new Date().toISOString().substr(0, 10)
    this.today = Date.parse(today)
    if (this.frentista) {
      this.pegarTodosItens()
      this.pegarTiposDePagamento()
    }
  },
  watch: {
    'pedido_data.data_entrega_prevista' (val) {
      this.menu = false
      if (val) {
        this.formatDate(val)
      }
    },
    eh_mesmo_endereco (val) {
      if (!val) {
        this.endereco_entrega = {
          logradouro: undefined,
          numero: undefined,
          bairro: undefined,
          cidade: undefined,
          estado: undefined,
          cep: undefined,
          complemento: undefined,
          latitude: undefined,
          longitude: undefined
        }
      }
    }
  },
  methods: {
    activeAlert (texto, tipo) {
      this.alerta = texto
      this.tipo = tipo
      const interval = setInterval(() => {
        this.alerta = undefined
        clearInterval(interval)
      }, 5000)
    },
    formatarValor (valor) {
      if (!valor) return 0
      if (this.isNumber(valor)) return valor
      return Number(valor.replaceAll('.', '').replace(',', '.'))
    },
    formatDate (date) {
      this.data_entrega_prevista_formatada = date
        .split('-')
        .reverse()
        .join('/')
    },
    pegarTodosItens () {
      const data = {
        parameters: {}
      }
      this.$store.dispatch('itens', data).then(json => {
        this.itens = json
      })
    },
    adicionarItem () {
      if (!this.item) {
        this.activeAlert('Você precisa selecionar um item', 'error')
        return
      }
      if (this.quantidade <= 0) {
        this.activeAlert('Você precisa digitar uma quantidade maior que zero', 'error')
        return
      }
      if (this.item.quantidade_disponivel && this.quantidade > this.item.quantidade_disponivel) {
        this.activeAlert('Você não pode adicionar mais itens do que o item possui', 'error')
        return
      }
      if (this.itens_pedido.find(item => item.id === this.item.id)) {
        this.activeAlert('Você já adicionou este item ao pedido', 'error')
        return
      }
      this.itens_pedido.push({ ...this.item, quantidade: this.quantidade })
      this.item = undefined
      this.quantidade = 1
    },
    removerItem () {
      this.itens_pedido.splice(this.index, 1)
    },
    pegarTiposDePagamento () {
      this.$store.dispatch('pegarTiposDePagamento').then(json => {
        this.tipos_pagamentos = json.filter((tp) => tp.referencia !== 'carteira_digital' && tp.referencia !== 'cashback')
      })
    },
    async buscarCoordenadas () {
      const json = await this.$store.dispatch('pegarCoordenadas', {
        logradouro: this.endereco_entrega.logradouro,
        numero: this.endereco_entrega.numero,
        bairro: this.endereco_entrega.bairro,
        cidade: this.endereco_entrega.cidade,
        estado: this.endereco_entrega.estado
      })

      if (!json || !json.latitude || !json.longitude) {
        return
      }
      this.endereco_entrega.latitude = json.latitude
      this.endereco_entrega.longitude = json.longitude
    },
    searchCep () {
      this.cepValido = false
      if (!this.endereco_entrega.cep || this.step !== 3) return
      if (this.endereco_entrega.cep.length !== 8) return
      fetch(`https://viacep.com.br/ws/${this.endereco_entrega.cep}/json/`,
        {
          method: 'get',
          mode: 'cors',
          headers: { 'Accept': 'application/json' }
        })
        .then(res => res.json())
        .then(json => {
          this.endereco_entrega.logradouro = json.logradouro
          this.endereco_entrega.bairro = json.bairro
          this.endereco_entrega.cidade = json.localidade
          this.endereco_entrega.estado = json.uf
          this.cepValido = true
        })
    },
    isNumber (value) {
      return typeof value === 'number' && !isNaN(value)
    },
    nextStep () {
      if (this.step === 1) {
        if (this.itens_pedido.length === 0) return
        this.pedido_data.itens_pedido = this.itens_pedido.map(item => {
          return {
            item_id: item.id,
            categoria: item.categoria.id,
            quantidade: this.formatarValor(item.quantidade)
          }
        })
        this.step = 2
      } else if (this.step === 2) {
        this.step = 3
        this.pedido_data.taxa_entrega = this.formatarValor(this.pedido_data.taxa_entrega)
        this.pedido_data.desconto = this.formatarValor(this.pedido_data.desconto)
        this.pedido_data.subtotal = this.subtotal
        this.pedido_data.total = this.valor_total
        this.pedido_data.tipo_pagamento = this.tipo_pagamento_selecionado.id_tipo_pagamento
      } else if (this.step === 3) {
        if (!this.eh_mesmo_endereco && this.$refs.formEnderecoEntrega.validate()) {
          this.buscarCoordenadas()
          this.pedido_data.endereco_entrega = this.endereco_entrega
        } else {
          this.pedido_data.endereco_entrega = this.cliente.endereco
        }
        this.step = 4
      } else {
        this.salvar()
      }
    },
    async salvar () {
      const data = {
        method: 'POST',
        body: {
          ...this.pedido_data,
          empresa_vendedora: this.empresa.cnpj,
          id_frentista: this.id_frentista,
          id_pessoa: this.cliente.id_pessoa
        }
      }
      this.$store.dispatch('pedidosMultiMethods', data).then(() => {
        this.$emit('cadastroRealizado')
        this.fecharCard()
      })
    },
    limpar () {
      this.$refs.formStep1.reset()
      this.$refs.formStep2.reset()
      this.step = 1
    },
    fecharCard () {
      // this.limpar()
      this.$emit('fechar')
    }
  }
}
</script>

<style scoped>
.headline {
    padding: 16px 24px;
}

.v-card__actions {
    padding: 16px 24px;
}
</style>
